import React from 'react';
import { Node } from 'slate';
import * as serializer from 'basic-editor-value-serializer';
import { ReactComponent as Icon } from 'assets/images/node-options-control-icon.svg';
import ExpandableNodeActionMenuItem from './menu-item';
import IconSettingsReact from './icon-settings/react';
import * as settings from '../helpers/utilities/icon/settings';
import nodeControls from './control-types';

function content(menu) {
  function read() { return settings.read(menu.editor, menu.elementPath); }
  function write(changes) { settings.write(menu.editor, menu.elementPath, changes); }
  function remove() { settings.remove(menu.editor, menu.elementPath); }
  const attached = serializer.utilities.node.icon.isAttached(Node.get(menu.editor, menu.elementPath));
  return <IconSettingsReact attached={attached} value={menu.editor.children} read={read} write={write} remove={remove} onResize={menu.positionToolbar} />;
}

export function tryRenderIconSettings(menu) {
  if (menu.customNodeControls.indexOf(nodeControls.ICON_SETTINGS) === -1) {
    return null;
  }
  return <ExpandableNodeActionMenuItem Icon={Icon} name="Icon settings" activeMenuItemName={menu.activeMenuItemName}
    contentRenderer={content.bind(null, menu)} positionToolbar={menu.positionToolbar} toggleActiveMenuItem={menu.toggleActiveMenuItem} />;
}
